import { createAction, createSlice } from "@reduxjs/toolkit";
import { Announcement, AnnouncementQueryParams } from "../type";
import {
	languages,
	NOTIFICATION_ROUTER_SETTING,
	notificationSettingTypes,
} from "constants/constants";
import { RootState } from "store/store";

export const initialAnnouncement = {
	id: 0,
	status: "Unsent",
	schedule: "",
	userGroupType: "customer",
	sentTime: "",
	settingType: notificationSettingTypes[1]?.value,
	routerSetting: {
		type: NOTIFICATION_ROUTER_SETTING.EXTERNAL_LINK,
		screenKey: "",
		parameter: "",
		link: "",
	},
	translations: languages.map(val => ({
		image: "",
		title: "",
		body: "",
		bodyHtml: "",
		language: val.key,
	})),
};

export interface AnnouncementState {
	announcementList: Announcement[];
	announcementDetail: Announcement;
	announcementManageTotal: number;
}

const initialState: AnnouncementState = {
	announcementList: [],
	announcementDetail: initialAnnouncement,
	announcementManageTotal: 0,
};

export const announcementManageSlice = createSlice({
	name: "announcementManage",
	initialState,
	reducers: {
		setListAnnouncement: (state, action) => {
			state.announcementList = action.payload.data;
			state.announcementManageTotal = action.payload.total;
		},
		setDetailAnnouncement: (state, action) => {
			state.announcementDetail = action.payload.data;
		},
	},
});

export const { setListAnnouncement, setDetailAnnouncement } =
	announcementManageSlice.actions;

export const selectAnnouncementList = (state: RootState) =>
	state.announcement.announcementList;
export const selectAnnouncementDetail = (state: RootState) =>
	state.announcement.announcementDetail;
export const selectAnnouncementManageTotal = (state: RootState) =>
	state.announcement.announcementManageTotal;

export interface GetListAnnouncementPayload {
	query: AnnouncementQueryParams;
	callback: () => void;
}

export const getListAnnouncementAsync = createAction(
	"announcementManage/getListAnnouncementAsync",
	payload => ({
		payload,
	}),
);

export interface GetDetailAnnouncementPayload {
	id: string;
	callback: () => void;
}

export const getDetailAnnouncementAsync = createAction(
	"announcementManage/getDetailAnnouncementAsync",
	payload => ({
		payload,
	}),
);

export interface CreateAnnouncementPayload {
	data: Announcement;
	callback: () => void;
}

export const createAnnouncementAsync = createAction(
	"announcementManage/createAnnouncementAsync",
	payload => ({
		payload,
	}),
);

export interface UpdateAnnouncementPayload {
	id: string;
	callback: () => void;
	data: Announcement;
}

export const updateAnnouncementAsync = createAction(
	"announcementManage/updateAnnouncementAsync",
	payload => ({
		payload,
	}),
);

export interface DeleteAnnouncementPayload {
	id: string;
	callback: () => void;
	query: AnnouncementQueryParams;
}

export const deleteAnnouncementAsync = createAction(
	"announcementManage/deleteAnnouncementAsync",
	payload => ({
		payload,
	}),
);

export default announcementManageSlice.reducer;
